import { ServiceLanding } from '@rover/rsdk/src/apiClient/latest';
import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import { fullApiUrl } from '@rover/utilities/apiUrl';

import DefaultAPIErrorHandler from '../../../apis/DefaultAPIErrorHandler';

export const SERVICE_LANDING_URL: string = fullApiUrl('frontend/service-landing/');
export const get = async ({
  countryUrlPrefix,
  translatedServiceLandingSlug,
}): Promise<ServiceLanding> => {
  const ai = getAxiosInstance();
  const path = countryUrlPrefix
    ? `${countryUrlPrefix}/${translatedServiceLandingSlug}`
    : `${translatedServiceLandingSlug}`;

  try {
    const { data } = await ai.get(`${SERVICE_LANDING_URL}${path}/`, {
      withCredentials: true,
    });
    return camelize(data, true) as ServiceLanding;
  } catch (e: any) {
    return DefaultAPIErrorHandler(e, 'There was an error while fetching service landing.');
  }
};
